export default "__VITE_ASSET__CwEoVqKw__"